import React from 'react';
import { FormAppContext } from '../hooks/use-form-app';
import LayerPickerAvailableLayersListItem from './layer-picker-available-layers-list-item';
import ExcessivelyLargeKMLLayerListItem from './excessively-large-kml-layer-list.item';

interface Props {
  onClick: (item: any) => void,
  availableLayers: Array<any>,
  esriEnabled: boolean,
}

const KML_FILE_SIZE_LIMIT_IN_MB = 10; // 10MB;
const fileSizeInMB = (fileSize) => Math.floor(fileSize / 1048576);

export default class LayerPickerAvailableLayersList extends React.Component<Props> {
  static contextType = FormAppContext;

  render() {
    // @ts-ignore
    const { styles } = LayerPickerAvailableLayersList;

    return (
      <div className={styles.container}>
        {this.renderItems()}
      </div>
    );
  }

  renderItems() {
    const { esriEnabled, availableLayers } = this.props;

    return availableLayers.map((item) => {
      if (item.type === 'kml' && !esriEnabled) {
        return null;
      }

      if (item.type === 'kml' && fileSizeInMB(item.fileSize) > KML_FILE_SIZE_LIMIT_IN_MB) {
        console.log('Too big KML layer item:', item.name);
        return (
          <ExcessivelyLargeKMLLayerListItem
            key={`excessively-large-kml-layer-${item.name}`}
            item={item}
          />
        );
      }

      return (
        <LayerPickerAvailableLayersListItem
          key={`available-layer-${item.name}`}
          onClick={this.handleClick}
          item={item}
          active={this.isOverlayActive(item)}
        />
      );
    });
  }

  isOverlayActive(layer) {
    return this.context?.layerSettings.isOverlayActive(layer);
  }

  handleClick = (item) => {
    // @ts-ignore
    this.props.onClick(item);
  };
}
// @ts-ignore
const styles = cssInJS({
  container: {
    height: '100%',
    overflowY: 'auto',
  },
});
// @ts-ignore
LayerPickerAvailableLayersList.styles = styles;
